"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersistentId2 = exports.usePersistentId = void 0;
var React = __importStar(require("react"));
var services_1 = require("../../services");
var getId = function (seed, exact) {
    if (exact === void 0) { exact = true; }
    return exact && seed ? seed : services_1.uniqueIdService.getId(seed);
};
var usePersistentId = function (seed, exact) {
    var _a = React.useState(getId(seed, exact)), uniqueId = _a[0], setUniqueId = _a[1];
    var updateId = function (update, updateExact) {
        return setUniqueId(getId(update, updateExact));
    };
    return [uniqueId, updateId];
};
exports.usePersistentId = usePersistentId;
var usePersistentId2 = function (id) {
    var uniqueId = React.useState(id !== null && id !== void 0 ? id : services_1.uniqueIdService.getId())[0];
    return uniqueId;
};
exports.usePersistentId2 = usePersistentId2;
